import { render, staticRenderFns } from "./user-center-lpservices.vue?vue&type=template&id=ef2201a2&scoped=true"
import script from "./user-center-lpservices.vue?vue&type=script&lang=js"
export * from "./user-center-lpservices.vue?vue&type=script&lang=js"
import style0 from "./user-center-lpservices.vue?vue&type=style&index=0&id=ef2201a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2201a2",
  null
  
)

export default component.exports